import React from 'react';
import styled from 'styled-components';
import Table from './Table';

const GroupTableWrapper = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const GroupTable: any = (props) => {
  const { groupoftable, dark } = props;

  const renderTables = groupoftable.map((table) => {
    return <Table {...table} key={table.contentful_id} dark={dark} />;
  });

  return <GroupTableWrapper>{renderTables}</GroupTableWrapper>;
};

export default GroupTable;
